import { MembershipTypeNumbers } from '@components/_membership/progress-bar'
import { LoyaltyStatusQuery } from '@generated'

export function getMembershipNo(data: LoyaltyStatusQuery): MembershipTypeNumbers | 1 {
  if (!data || !data.loyaltyStatus || !data.loyaltyStatus.loyalty_nr) {
    return 5 // non-member
  }

  return data.loyaltyStatus.loyalty_nr as MembershipTypeNumbers
}
